module.exports = __webpack_public_path__ + "img/a_homeWork.da1d47b3.png";